var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ToastContainer as RootToastContainer, toast, } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';
import { ToastMessage } from '../components/ToastMessage';
export function ToasterExample() {
    var notify = useToast();
    return (_jsxs(_Fragment, { children: [_jsx("button", __assign({ onClick: function () {
                    return notify({
                        message: 'here',
                        type: 'warning',
                        actionLabel: 'test',
                        onClick: function () { return console.log('click'); },
                    });
                } }, { children: "Notify!" }), void 0),
            _jsx(ToastContainer, {}, void 0)] }, void 0));
}
export function ToastContainer(props) {
    return (_jsx(StyledToaster, { children: _jsx(RootToastContainer, __assign({}, props), void 0) }, void 0));
}
export function useToast() {
    return function (_a) {
        var autoClose = _a.autoClose, position = _a.position, props = __rest(_a, ["autoClose", "position"]);
        toast(function (t) {
            console.log(t);
            return (_jsx(ToastMessage, __assign({}, props, { actionClose: autoClose ? t.closeToast : undefined }), void 0));
        }, {
            autoClose: 10000000,
            style: { padding: 0, margin: 0 },
            position: position,
        });
    };
}
var StyledToaster = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .Toastify__toast-container--top-right {\n    top: 90px;\n  }\n  .Toastify__toast-container--top-center {\n    top: 90px;\n  }\n  .Toastify__toast-container--top-left {\n    top: 90px;\n  }\n\n  .Toastify__toast {\n    min-height: 0;\n    width: auto;\n    margin-bottom: 5px !important;\n    margin-top: 5px !important;\n  }\n  .Toastify__toast-body {\n    padding: 0 !important;\n  }\n  .Toastify__close-button {\n    display: none;\n  }\n  .Toastify__progress-bar--default {\n    background: red !important;\n    height: 1px;\n  }\n"], ["\n  .Toastify__toast-container--top-right {\n    top: 90px;\n  }\n  .Toastify__toast-container--top-center {\n    top: 90px;\n  }\n  .Toastify__toast-container--top-left {\n    top: 90px;\n  }\n\n  .Toastify__toast {\n    min-height: 0;\n    width: auto;\n    margin-bottom: 5px !important;\n    margin-top: 5px !important;\n  }\n  .Toastify__toast-body {\n    padding: 0 !important;\n  }\n  .Toastify__close-button {\n    display: none;\n  }\n  .Toastify__progress-bar--default {\n    background: red !important;\n    height: 1px;\n  }\n"])));
var templateObject_1;
